export default __webpack_public_path__ + "static/media/activities_black.71001d49.svg";